import { render } from "./noticeDetail.vue?vue&type=template&id=0e9d03f2&scoped=true"
import script from "./noticeDetail.vue?vue&type=script&lang=js"
export * from "./noticeDetail.vue?vue&type=script&lang=js"

import "./noticeDetail.vue?vue&type=style&index=0&id=0e9d03f2&lang=css"
import "./noticeDetail.vue?vue&type=style&index=1&id=0e9d03f2&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9d03f2"]])

export default __exports__